import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AdministrationComponent } from './administration.component';
import { TableModule } from 'primeng/table';
import { PanelModule } from 'primeng/panel';
import { ButtonModule } from 'primeng/button';
import { DialogueUserComponent } from './dialogue-user/dialogue-user.component';
import {DialogModule} from 'primeng/dialog';
import {DropdownModule} from 'primeng/dropdown';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {InputTextModule} from 'primeng/inputtext';
import {ConfirmDialogModule} from 'primeng/confirmdialog';
import {ConfirmationService} from 'primeng/api';
import { PasswordComponent } from './password/password.component';


@NgModule({
  declarations: [AdministrationComponent, DialogueUserComponent, PasswordComponent],
  imports: [
    CommonModule,
    TableModule,
    PanelModule,
    ButtonModule,
    DialogModule,
    DropdownModule,
    FormsModule,
    InputTextModule,
    ReactiveFormsModule,
    ConfirmDialogModule,
    InputTextModule
  ]
})
export class AdministrationModule { }
